import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsTrophyNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3 .625C3 .28 3.28 0 3.625 0h8.75c.345 0 .625.28.625.625V1h1.708C15.422 1 16 1.578 16 2.292v2.416A3.292 3.292 0 0112.708 8h-.339a6.705 6.705 0 01-3.744 3.448v1.22l3.226 2.19A.625.625 0 0111.5 16h-7a.625.625 0 01-.35-1.142l3.225-2.19v-1.22A6.705 6.705 0 013.631 8h-.34A3.292 3.292 0 010 4.708V2.292C0 1.578.578 1 1.292 1H3zM13 5.16c0 .543-.066 1.076-.19 1.588a2.042 2.042 0 001.94-2.04V2.292a.042.042 0 00-.042-.042H13zm-10 0V2.25H1.292a.042.042 0 00-.042.042v2.416c0 1.094.86 1.987 1.94 2.04A6.705 6.705 0 013 5.16zm1.25-3.91v3.91A5.456 5.456 0 008 10.342a5.456 5.456 0 003.75-5.182V1.25zM8 13.755l-1.466.995h2.932z"
        fill=""
      />
    </svg>
  )
);
SvgAchievementsTrophyNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsTrophyNormalXsmall;
